<span
  class="icon"
  [ngClass]="availableStatuses.includes(status) ? 'icon-success' : 'icon-failure'">
  <span class="path1"></span>
  <span class="path2"></span>
</span>
